/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Plan_Tab_Billing_PeriodInputs */



/**
* | output |
* | --- |
* | "Billing period: {start} → {end}" |
*
* @param {Plan_Tab_Billing_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_billing_period = /** @type {((inputs: Plan_Tab_Billing_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Billing_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abrechnungszeitraum: ${i?.start} → ${i?.end}`)
	return /** @type {LocalizedString} */ (`Billing period: ${i?.start} → ${i?.end}`)
});